import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

import { Dispatch } from "../StateManager/state";
import { Filters } from "./Filters";
import { PageList } from "./PageList";

type Props = Readonly<{
  activePage: number;
  dispatch: Dispatch;
  highConfidenceThreshold: number;
  noteCount: number;
  notes: React.ReactElement;
  pageConfidences: Array<number>;
  pageImageURIs: ReadonlyArray<string>;
}>;

export const PagePreview = ({
  activePage,
  dispatch,
  highConfidenceThreshold,
  noteCount,
  notes,
  pageConfidences,
  pageImageURIs,
}: Props) => {
  const [activeTab, setActiveTab] = useState("pages");
  const [threshold, setThreshold] = useState(highConfidenceThreshold);
  const [showAll, setShowAll] = useState(false);
  return (
    <div className="page-preview">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === "pages" ? "active" : ""}
            onClick={() => {
              setActiveTab("pages");
            }}
          >
            Pages
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "notes" ? "active" : ""}
            onClick={() => {
              setActiveTab("notes");
            }}
          >
            Notes{noteCount > 0 && <> ({noteCount})</>}
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane className="pages-tab" tabId="pages">
          <div className="d-flex flex-column h-100">
            <Filters
              resetThreshold={() => {
                setThreshold(highConfidenceThreshold);
              }}
              setThreshold={setThreshold}
              showAll={showAll}
              threshold={threshold}
              toggleShowAll={() => {
                setShowAll(!showAll);
              }}
            />
            <PageList
              activePage={activePage}
              dispatch={dispatch}
              highConfidenceThreshold={threshold}
              pageConfidences={pageConfidences}
              pageImageURIs={pageImageURIs}
              showAll={showAll}
            />
          </div>
        </TabPane>
        <TabPane className="notes-tab" tabId="notes">
          {notes}
        </TabPane>
      </TabContent>
    </div>
  );
};
